import React from "react";
import { Table, Collapse, Tooltip } from "antd";

import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

const DataDiagnosticRightBar = [
  RightBarMethod(" ", "", <i className=""></i>, [
    RightBarMethod("", "", "", "", ""),
  ]),
];
const { Panel } = Collapse;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Phone Number",
    dataIndex: "phoneNumber",
  },
  {
    title: "Action",
    dataIndex: "",
    key: "x",
    render: () => <span className="onclick-text">Fix</span>,
  },
];
const data = [
  {
    key: "1",
    name: "Sandra Meyers",
    type: "Owner",
    phoneNumber: "	916 718-0933 Pat",
  },
  {
    key: "2",
    name: "Tifanie Womack",
    type: "Prospect",
    phoneNumber: "	(485) 431-8473",
  },
];
const text = <span style={{color:'#000'}}>Invalid phone numbers can prevent you from texting or calling contacts from the application.</span>;
function DataDiagnostic() {
 
  return (
    <>
      <div>
        <PageHeading heading="Data Diagnostic" />
        <Collapse defaultActiveKey={["1"]} ghost>
          <Panel header={<div>Phone Numbers  <Tooltip placement="bottom" title={text} color={['#fff']}>
          <i className="fa-solid fa-circle-question" style={{color:'#006eb7',cursor:'pointer'}}></i>
      </Tooltip></div>} key="1">
            <Table columns={columns} dataSource={[]} />
          </Panel>
        </Collapse>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={DataDiagnosticRightBar} />
      </div>
    </>
  );
}

export default DataDiagnostic;
